import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {DiscountAuditReportData} from "./discount-audit-report.data";

@Injectable()
export class DiscountAuditReportModel extends ReportModel<DiscountAuditReportData> {
    constructor(injector: Injector) {
        super(injector, DiscountAuditReportData);
    }
}
